import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Section1 from "../components/smarttv/section1";
import Tutorial from "../components/smarttv/tutorial";
import Section3 from "../components/smarttv/section3";
import Question from "../components/smarttv/question";
import Footer from "../components/navigation/Footer";

const InstallSmartTv = ({strellatv}) => {
    return (
        <Layout>
            {strellatv &&
                (
                    <>
                        <Section1 data={strellatv}/>
                        <Tutorial data={strellatv}/>
                        <Section3/>
                        <Question/>
                        <Footer/>
                    </>
                )
            }
        </Layout>
    );
};


const mapStateToProps = state => ({
    strellatv: state.Home.strellatv,
})

export default connect(mapStateToProps, {})(InstallSmartTv)
